import React from 'react';

import PageLayout from '../../components/PageLayout';
import Spacer from '../../components/Spacer';
import ContentContainer from '../../components/ContentContainer';
import LetsWorkTogether from '../../components/LetsWorkTogether';
import QuickLinks, { LinkItem } from '../../components/QuickLinks';
import BookMeetingWithUs from '../../components/BookMeetingWithUs';
import LatestBehancePost from '../../components/LatestBehancePost';
import OtherSites from '../../components/OtherSites';
import Row from '../../components/Row';

import Background from './images/img-bg-header-contact.png';

const ContactPage = () => (
  <PageLayout
    title="Contact"
    header="What did you have in mind?"
    intro="Select from one of the options below and we will get back to your request as soon as humanly possible."
    visual={Background}
    useGradient={false}
  >
    <Row>
      <ContentContainer>
        <QuickLinks>
          <LinkItem key={1} to="/contact#book-meeting">
            Book a meeting
          </LinkItem>
          <LinkItem key={2} to="/about">
            See our story
          </LinkItem>
          <LinkItem key={3} to="/contact#get-in-touch">
            Send a message
          </LinkItem>
        </QuickLinks>
      </ContentContainer>
    </Row>

    <img
      src={require('./images/img-contact.jpg')}
      alt=""
      style={{ width: '100%' }}
    />

    <Spacer height={140} />

    <center>
      <h2>More ways to connect</h2>

      <p
        style={{
          maxWidth: '400px',
          lineHeight: '2',
          fontSize: '18px',
          color: '#777777',
        }}
      >
        Select from these options and we'll route your request to the
        appropriate person.
      </p>

      <OtherSites size="small" />
    </center>
    <Spacer height={140} />

    <BookMeetingWithUs />
    <Spacer height={140} />

    <LatestBehancePost />
    <Spacer height={140} />

    <LetsWorkTogether />
  </PageLayout>
);

export default ContactPage;
